import { TextStylePreset, Typography } from '@vivaldis/antd-ui'
import { useTranslation } from 'react-i18next'

export const NotSetValue = () => {
  const [t] = useTranslation('web_ui')

  return (
    <Typography.Text preset={TextStylePreset.Regular12}>
      {t('employee_profile.not_set')}
    </Typography.Text>
  )
}
